// extracted by mini-css-extract-plugin
export var Contact = "Contact-module--Contact--Z-0ea";
export var Title = "Contact-module--Title--1R5UC";
export var Subtitle = "Contact-module--Subtitle--6p6Mh";
export var MailAddress = "Contact-module--MailAddress--htKLI";
export var SubmitButton = "Contact-module--SubmitButton--oR2rN";
export var Error = "Contact-module--Error--707qM";